import { render, staticRenderFns } from "./UserDocumentLinks.vue?vue&type=template&id=11cb9424&scoped=true"
import script from "./UserDocumentLinks.vue?vue&type=script&lang=js"
export * from "./UserDocumentLinks.vue?vue&type=script&lang=js"
import style0 from "./UserDocumentLinks.vue?vue&type=style&index=0&id=11cb9424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cb9424",
  null
  
)

export default component.exports